import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HumanDatePipe } from './pipes/human-date.pipe';
import {
  BoughtInquiryStatusClassPipe,
  BoughtInquiryStatusPipe,
  InquiryAvailability,
  InquiryFloor,
  InquiryObjectType,
  InquiryRooms,
  InquiryStatusPipe,
  ServiceTypePipe
} from './pipes/inquiry-pipe.pipe';

const pipes = [
  HumanDatePipe,
  InquiryStatusPipe,
  ServiceTypePipe,
  BoughtInquiryStatusPipe,
  BoughtInquiryStatusClassPipe,
  InquiryRooms,
  InquiryObjectType,
  InquiryAvailability,
  InquiryFloor,
]

@NgModule({
  declarations: [...pipes],
  imports: [CommonModule],
  exports: [...pipes],
})
export class PipeModule {
}
